


















































import { get } from 'lodash';
import { BFormInput } from 'bootstrap-vue';
import ZenMultiselect from '@reciprocity/multiselect';
import { PERIODS, PeriodOptions } from './utils';
import { buildCustomRepeatQuickSuggestions } from './suggestions';

export default {
  name: 'CustomRepeat',
  components: {
    BFormInput,
    ZenMultiselect,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      PERIODS,
    };
  },
  computed: {
    repeatOptions() {
      const period = get(this.form, 'period.value', PeriodOptions.Weekly);
      return buildCustomRepeatQuickSuggestions(this.form.endDate, [period]);
    },
  },
  watch: {
    'form.endDate'() {
      let existingElement;
      const repeatOn = get(this.form, 'repeatOn.value');
      if (repeatOn) {
        existingElement = this.repeatOptions.find(opt => opt.value === repeatOn);
      }

      if (existingElement) {
        this.form.repeatOn = existingElement;
      } else {
        this.form.repeatOn = this.repeatOptions[0];
      }
    },
    'form.period'() {
      this.form.repeatOn = this.repeatOptions[0];
    },
  },
  created() {
    if (!this.form.period) {
      this.form.period = PERIODS[0];
    }
    if (!this.form.repeatOn) {
      this.form.repeatOn = this.repeatOptions[0];
    }
  },
  methods: {
    pluralize(count: string, type: string): string {
      return parseInt(count, 10) > 1 ? type + 's' : type;
    },
  },
};
